export default {"src":"/_next/static/media/Email.75a682ce.svg","height":33,"width":89,"blurWidth":0,"blurHeight":0};